import { PaletteColor } from '../palette';
import { typography } from '../typography';

export const MuiAccordion = (primaryColour: Partial<PaletteColor>, greyColour: Partial<PaletteColor>) => {
  return {
    defaultProps: {
      square: false,
      disableGutters: true,
    },
    styleOverrides: {
      root: {
        borderRadius: '8px',
        backgroundColor: 'white',
        border: `1px solid ${greyColour[200]}`,
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        '&:before': {
          display: 'none',
        },
        '&.Mui-expanded': {
          margin: 0,
        },
      },
    },
    variants: [
      {
        // Borderless, shadowless accordion variant
        props: { variant: 'borderless' },
        style: {
          border: 'none',
          boxShadow: 'none',
          padding: 0,
          '.MuiAccordionSummary-root':{
            padding: 0,
          },
          '.MuiAccordionDetails-root':{
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
      },
    ],
  };
};

export const MuiAccordionSummary = (primaryColour: Partial<PaletteColor>, greyColour: Partial<PaletteColor>) => {
  return {
    styleOverrides: {
      root: {
        ...typography.textSM,
        fontWeight: 600,
        color: greyColour[900],
        minHeight: '48px',
        padding: '0 16px',
        '& .MuiAccordionSummary-content': {
          margin: '12px 0',
          '&.Mui-expanded': {
            margin: '12px 0',
          },
        },
        '&.Mui-expanded': {
          minHeight: '48px',
        },
      },
    },
  };
};

export const MuiAccordionDetails = (_primaryColour: Partial<PaletteColor>, greyColour: Partial<PaletteColor>) => {
  return {
    styleOverrides: {
      root: {
        padding: '16px',
        borderTop: `1px solid ${greyColour[100]}`,
      },
    },
  };
};
